<template>

  <v-card style="background-color:#080404">
    <!-- Title -->
    <v-card-title class="text-h5 pb-4" style="border-bottom:1px solid #353535;">
      <span v-if="testMode">Add Test Order to Route</span>
      <span v-else>Add Order to Route</span>
    </v-card-title>

    <!-- Order cards -->
    <v-card-text class="pa-0 ma-0 pt-2 px-3" style="height:500px;">
      <template v-if="loadedOrderItems && loadedOrderItems.length > 0">
        <v-row class="pa-0 ma-0">
          <v-col
              cols="12"
              sm="6"
              v-for="(order, index) in loadedOrderItems"
              :key="`order-${index}`"
              :ref="order.id"
              :class="{ active: order.id === selectedOrder.id }">
            <order-card
                :order="order"
                v-on:itemClicked="setSelectedOrder(order)" />
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <div style="text-align:center">(No remaining orders to schedule)</div>
      </template>
    </v-card-text>

    <!-- Actions -->
    <v-card-actions class="mt-2 pt-4" style="border-top:1px solid #353535;">
      <v-btn text color="primary" width="90" @click="emitCancel">
        Cancel
      </v-btn>
      <v-spacer />
      <v-btn color="primary" width="140" :disabled="!selectedOrder.id" @click="emitSelection">
        Add Order
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import OrderCard from '@/components/orders/OrderCard'

export default {
  name: 'RouteOrderSelector',

  components: {
    OrderCard
  },

  props: {
    orderFilters: {
      type: Object,
      default: () => {}
    },
    testMode: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isDataLoading: false,
      loadedOrderMeta: {},
      loadedOrderItems: null,
      selectedOrder: {}
    }
  },

  async beforeMount () {
    this.isDataLoading = true

    // TODO - Support pagination !!!

    // Fetch PLACED orders
    try {
      const orders = await this.$store.dispatch('sh/dataApi', {
        method: 'get',
        uri: 'orders',
        opts: {
          params: {
            with: 'shipper,receiver',
            is_test: this.testMode,
            order_status: 'PLACED'
          }
        }
      })

      this.loadedOrderMeta = orders.meta
      this.loadedOrderItems = orders.items
    } catch (err) {
      console.log('Error retrieving orders =>', err)
    }

    this.isDataLoading = false
  },

  beforeDestroy () {
    this.selectedOrder = {}
  },

  methods: {
    emitCancel () {
      this.selectedOrder = {}
      this.$emit('canceled')
    },

    emitSelection () {
      this.$emit('selected', this.selectedOrder)
    },

    setSelectedOrder (order) {
      this.selectedOrder = order
    }
  }
}
</script>

<style scoped>
</style>
